import BaseApiController from 'controller/baseresourcecontroller';

export default class SecurityController extends BaseApiController {
  constructor () {
    super('mvc/security');
  }
  /**
   * @param  {SecurityAction[]} resourcecodes Array of SecurityActions
   */
  async GetAuthorization (resourcecodes) {
    return super.Post('getauthorization', resourcecodes);
  }
}
